// Shared helpers/constants for the document action-log admin view.

export const ACTION_OPTIONS = [
  "checkout",
  "recall-checkout",
  "checkin",
  "upload",
  "recall-save",
  "delete",
];

export const RESULT_OPTIONS = ["success", "rejected-empty", "locked", "error"];

// Maps a log result to a MUI Label color.
export const resultColor = (result) => {
  switch (result) {
    case "success":
      return "success";
    case "rejected-empty":
    case "locked":
      return "warning";
    case "error":
      return "error";
    default:
      return "default";
  }
};

// Human-readable byte size; tolerant of missing values.
export const formatBytes = (bytes) => {
  if (bytes === null || bytes === undefined || isNaN(bytes)) {
    return "—";
  }
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  const kb = bytes / 1024;
  if (kb < 1024) {
    return `${kb.toFixed(1)} KB`;
  }
  return `${(kb / 1024).toFixed(1)} MB`;
};
